import { useNavigate } from 'react-router-dom';

import usePageMetadata from '../../hooks/usePageMetadata';
import FitFinder from './FitFinder';
import './FitsPage.css';

const FitFinderPage = () => {
  const navigate = useNavigate();
  usePageMetadata(
    'ISO 286 Fit Finder | ASiJoLab',
    'Define a required clearance, transition, or interference range and find verified ISO 286 fit combinations.'
  );

  const useFit = ({ diameter, hole, shaft }) => {
    const query = new URLSearchParams({ diameter: String(diameter), hole, shaft });
    navigate(`/tolerances/fits?${query}`);
  };

  return (
    <main className="fitsPage">
      <header className="fitsPageHeader">
        <p>Tolerances · ISO 286</p>
        <h1>ISO 286 Fit Finder</h1>
        <span>Define the required functional clearance or interference range and search verified ISO 286 tolerance combinations.</span>
      </header>
      <FitFinder onSelect={useFit} />
    </main>
  );
};

export default FitFinderPage;
